import { registerPropertyManagerSection } from '@/core';
import ChamferPropertySection from '@/components/editor/property-manager/blend/ChamferPropertySection.vue';

registerPropertyManagerSection({
  id: 'chamfer-feature',
  title: '倒角',
  order: 33,
  component: ChamferPropertySection,
  actions: {
    confirm: true,
    cancel: true,
  },
  resolveConfirmDisabled: (context) => context.chamferCanSubmit === false,
  isApplicable: (context) => {
    if (context.activeCommand === 'chamfer') {
      return true;
    }
    return context.chamferActive === true;
  },
  onConfirm: (context) => {
    void context.submitChamfer?.();
  },
  onCancel: (context) => {
    context.cancelBlend?.();
  },
});
